import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", ...props }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease, delay }}
      {...props}
    >
      {children}
    </motion.div>
  );
}

// Signature masked line-by-line reveal for hero headings
export function MaskedLines({ lines, className = "", delayStart = 0.15 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease, delay: delayStart + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
